// extracted by mini-css-extract-plugin
export default {"container":"SnackbarView_container__av8pk","snackbar":"SnackbarView_snackbar__gjgCM","message":"SnackbarView_message__F9VmH"};